import { get, post, put } from '@/common/admin_ajax'


const getPlate = (id) => get(`plates/${id}.json`)

const updatePlate = (id, data) => put(`plates/${id}/region.json`, data)

const getPlateRoads = (id, road_id) => get(`plates/${id}/plate_facilities/${road_id}.json`)

const updatePlateRoads = (id, road_id, data) => put(`plates/${id}/plate_facilities/${road_id}/coordinates.json`, data)

const getAllPlates = () => get('plates.json')


export default {
    getPlate,
    updatePlate,
    getPlateRoads,
    updatePlateRoads,
    getAllPlates
}
